/**
 * Map InviteFlow API errors (410 link_closed, 403 link_paused, etc.) to user-facing text.
 * Backend may send { detail } and/or { error, status }.
 */
export function inviteflowApiErrorMessage(err) {
  const data = err?.response?.data;
  if (!data) return null;
  const detail =
    (typeof data.detail === "string" && data.detail.trim()) ||
    (typeof data.Detail === "string" && data.Detail.trim()) ||
    null;
  if (detail) {
    return detail;
  }
  const status = (data.status || data.Status || "").toLowerCase();
  const code = data.error || data.Error || "";
  if (code === "link_paused") {
    return (
      data.detail ||
      "This invitation link is temporarily paused. Please try again later or contact your event administrator."
    );
  }
  if (code === "link_closed" || err?.response?.status === 410) {
    if (status === "submitted") {
      return (
        data.detail ||
        "This invitation link is closed because it has already been completed. Please contact your event administrator if you need assistance."
      );
    }
    if (status === "exhausted") {
      return (
        data.detail ||
        "All spots for this invitation have been used. Please contact your event administrator if you need assistance."
      );
    }
    if (status === "expired") {
      return (
        data.detail ||
        "This invitation link has expired. Please contact your event administrator if you need assistance."
      );
    }
    return (
      data.detail ||
      "This invitation link is no longer available. Please contact your event administrator if you need assistance."
    );
  }
  if (err?.response?.status === 403) {
    return data.detail || "This invitation link is not available.";
  }
  return null;
}
